import type { FaireProductEntity } from "../../entity_types/product";

export const p_hcv8jf7dm8: FaireProductEntity = {
  token: "p_hcv8jf7dm8",
  type: "product",
  name: "Moon Phase Crystal Shelf",
  brandToken: "b_x9gc7rccbx",
  brandName: "Mars & Me",
  imageUrl:
    "https://cdn.faire.com/fastly/e318864367160f4593e7aa326c2a66a6a8cb9236af5ad07734809b0b623a743e.jpeg",
  galleryImageUrls: [],
  priceDollars: 41.57,
  description:
    'Lasercut, triple layer,18.5"x5.5" moonphase hanging crystal wall shelf.',
  tags: [],
  msrpDollars: 83.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:02:06.871Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
